(function () {
    'use strict';

    angular.module("imApp").factory("paperLessPoService", ['$ihttp', function ($ihttp) {
        let service = {
            getPaperLessPo: function (parms) {
                return $ihttp.post({
                    method: 492,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
